import { memo } from "react";
import { TireSetInfoCardProps } from "./types";
import { useTranslate } from "helpers";
import { getDimensionSet, getTireManufacturers, getTireType } from "services/api/fleet/tires/helpers";

const Field: React.FC<{ label: string; value?: string | number | null; children?: React.ReactNode }> = ({ label, value, children }) => (
    <div className="border border-slate-200 bg-slate-50 p-3 rounded-sm min-h-[70px]">
        <div className="text-sm text-slate-600">{label}</div>
        {children ?? <div className="text-md font-medium text-slate-800 truncate">{value ?? "-"}</div>}
    </div>
);

const TireSetInfoCard: React.FC<TireSetInfoCardProps> = (props) => {
    const { tireSet } = props;
    const { t } = useTranslate();

    const tireType = getTireType(tireSet.tires);
    const dimension = getDimensionSet(tireSet.tires);
    const manufacturers = getTireManufacturers(tireSet.tires);

    const locationName = tireSet.vehicle?.name
        ? `${tireSet.vehicle.name} ${tireSet.vehicle.registrationPlate ? `[${tireSet.vehicle.registrationPlate}]` : ""}`
        : tireSet.warehouse?.name ?? "-";

    const locationType = tireSet.vehicle?.name ? "Vozilo" : tireSet.warehouse?.name ? "Skladište" : "-";

    return (
        <>
            {/* Osnovne informacije */}
            <div className="border-b border-slate-200 pt-4 px-4">
                <div className="text-sm font-bold text-slate-600 mb-3">Osnovne informacije</div>
                <div className="grid grid-cols-3 gap-3 mb-4">
                    <Field label="Kod seta" value={tireSet.code} />
                    
                    <Field label="Broj guma" value={tireSet.tires?.length ?? 0} />
                    <Field label="Dimenzija" value={dimension || "-"} />
                </div>
            </div>

            {/* Tip gume */}
            <div className="border-b border-slate-200 pt-4 px-4">
                <div className="text-sm font-bold text-slate-600 mb-3">Tip gume</div>
                <div className="grid grid-cols-3 gap-3 mb-4">
                    <Field label="Tip" value={tireType?.name} />
                    <Field label="Proizvođač" value={manufacturers || "-"} />
                </div>
            </div>

            {/* Lokacija */}
            <div className="pt-4 px-4">
                <div className="text-sm font-bold text-slate-600 mb-3">Lokacija</div>
                <div className="grid grid-cols-3 gap-3 mb-4">
                    <Field label="Tip lokacije" value={locationType} />
                    <Field label="Naziv" value={locationName} />
                </div>
            </div>
        </>
    );
};

export default memo(TireSetInfoCard);
